import { z } from 'zod';

export const sqlSnippetFormSchema = z.object({
  engineId: z.union([z.literal('mssql'), z.literal('pgsql'), z.literal('sqlite'), z.literal('mysql'), z.literal('oracle')]),
  label: z.string().min(1, 'Label is required'),
  prefix: z.string().min(1, 'Prefix is required'),
  description: z.string().optional().default(''),
  body: z.string().min(1, 'Snippet body is required'),
});

export type SqlSnippetFormValues = z.infer<typeof sqlSnippetFormSchema>;

export const sqlSnippetFormDefaultValues: SqlSnippetFormValues = {
  engineId: 'mssql',
  label: '',
  prefix: '',
  description: '',
  body: '',
};
